import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "w-full grid grid-cols-12 h-full flex-grow relative overflow-y-hidden" }
const _hoisted_2 = { class: "col-span-7 flex flex-col space-y-5 pr-7" }
const _hoisted_3 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Service Assessments ")
const _hoisted_5 = { class: "flex flex-row space-x-2" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Add New")
const _hoisted_7 = {
  key: 0,
  class: "col-span-full w-full flex flex-col space-y-2 py-4"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "flex flex-row space-x-3 items-center" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Update")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "w-full flex flex-col py-3" }, null, -1)
const _hoisted_12 = { class: "w-[41.67%] absolute ml-[58.33%] top-0 overflow-y-auto flex flex-col space-y-3 h-full border-l-[1px] pl-5 border-gray-300" }
const _hoisted_13 = { class: "w-full flex flex-row items-center justify-between bg-white sticky top-0 left-0 z-[99999999] space-x-3 border-b-[1px] border-gray-200" }
const _hoisted_14 = { class: "flex flex-row space-x-3 items-center w-full justify-between" }
const _hoisted_15 = { class: "flex flex-row space-x-3 items-center" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Notes ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Questions ")
const _hoisted_18 = { class: "flex flex-row space-x-1 items-center" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Are you sure?")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Yes")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("No")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Delete Assessment")
const _hoisted_23 = {
  key: 0,
  class: "flex flex-row space-x-2 py-1"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Add New")
const _hoisted_25 = { class: "w-full flex flex-col items-start justify-start" }
const _hoisted_26 = {
  key: 1,
  class: "w-full flex flex-col space-y-6"
}
const _hoisted_27 = { class: "w-full flex flex-col space-y-3 py-3 px-3 bg-grey100 rounded-lg" }
const _hoisted_28 = { class: "w-full h-[200px] rounded-[15px] bg-fadedGreen border-[1px] px-5 border-[#CDDFD7] relative flex flex-col space-y-4 items-center justify-center" }
const _hoisted_29 = ["onInput"]
const _hoisted_30 = { class: "w-full flex items-center justify-center" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("No question added yet")
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "h-[100px]" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_roof_header_text = _resolveComponent("roof-header-text")!
  const _component_roof_button = _resolveComponent("roof-button")!
  const _component_roof_normal_text = _resolveComponent("roof-normal-text")!
  const _component_roof_badge = _resolveComponent("roof-badge")!
  const _component_roof_textarea = _resolveComponent("roof-textarea")!
  const _component_roof_multiple_choice = _resolveComponent("roof-multiple-choice")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_roof_header_text, { size: "xl" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_roof_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addServiceAssessment()))
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ])
      ]),
      (_ctx.ServiceAssessments)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ServiceAssessments.data, (assessment, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(`rounded-md border-[1px] border-grey300 ${
            _ctx.selectedAssessment == assessment.uuid
              ? '!border-l-[5px] border-l-primaryOrange'
              : ''
          } px-4 py-4 w-full flex flex-row items-center justify-between space-x-3 cursor-pointer`),
                onClick: ($event: any) => (_ctx.selectedAssessment = assessment.uuid)
              }, [
                _createVNode(_component_roof_normal_text, { customClass: 'text-left' }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(assessment.name), 1)
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_roof_button, {
                    padding: 'py-1 px-3 !text-xs',
                    onClick: _withModifiers(($event: any) => (_ctx.showUpdateAssesment(assessment)), ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_roof_badge, {
                    color: 
                assessment.is_general
                  ? 'purple'
                  : assessment.category?.name
                  ? 'green'
                  : 'orange'
              
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(assessment.is_general
                  ? "All Services"
                  : assessment.category?.name || "No service"), 1)
                    ]),
                    _: 2
                  }, 1032, ["color"])
                ])
              ], 10, _hoisted_8))
            }), 128)),
            _hoisted_11
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              class: _normalizeClass(`py-2 cursor-pointer ${
                _ctx.selectedTab == 'notes'
                  ? 'border-b-[3px] border-primaryOrange'
                  : ''
              }`),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedTab = 'notes'))
            }, [
              _createVNode(_component_roof_normal_text, {
                customClass: 'font-semibold px-3',
                color: `${
                  _ctx.selectedTab == 'notes' ? 'text-primaryDark' : 'text-bodyLight'
                }`
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }, 8, ["color"])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(`py-2  cursor-pointer ${
                _ctx.selectedTab == 'questions'
                  ? 'border-b-[3px] border-primaryOrange'
                  : ''
              }`),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedTab = 'questions'))
            }, [
              _createVNode(_component_roof_normal_text, {
                customClass: 'font-semibold px-3',
                color: `${
                  _ctx.selectedTab == 'questions'
                    ? 'text-primaryDark'
                    : 'text-bodyLight'
                }`
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }, 8, ["color"])
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_18, [
            (_ctx.deleteState == 'active')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_roof_normal_text, { "custom-class": '!text-xs' }, {
                    default: _withCtx(() => [
                      _hoisted_19
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_roof_button, {
                    padding: 'py-1 px-2 !text-xs',
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.deleteAssessment(_ctx.selectedAssessment)), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_roof_button, {
                    padding: 'py-1 px-2 !text-xs',
                    "bg-color": '!bg-gray-100',
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.deleteState = 'inactive'), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  })
                ], 64))
              : (_openBlock(), _createBlock(_component_roof_button, {
                  key: 1,
                  padding: 'py-1 px-3 !text-xs',
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.deleteState = 'active'), ["stop"]))
                }, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 1
                }))
          ])
        ]),
        (_ctx.selectedTab == 'questions')
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createVNode(_component_roof_button, {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showAddQuestion())),
                padding: 'px-4 py-1',
                customClass: '!text-xs'
              }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_25, [
        (_ctx.selectedTab == 'notes')
          ? (_openBlock(), _createBlock(_component_roof_textarea, {
              key: 0,
              "custom-class": '!border-transparent ',
              modelValue: _ctx.noteContent,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.noteContent) = $event)),
              placeholder: 'Type here',
              "has-title": false,
              paddings: 'py-3 px-3',
              textAreaStyle: 'h-auto w-full text-left ',
              "update-value": _ctx.updatedContent,
              "tools-to-use": [
            'header',
            'image',
            'list',
            'checklist',
            'embed',
            'quote',
          ]
            }, null, 8, ["modelValue", "update-value"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_26, [
              (_ctx.selectedServiceAssessment)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.selectedServiceAssessment.questions)
                      ? (_openBlock(), _createBlock(_component_draggable, {
                          key: 0,
                          handle: ".handle",
                          class: _normalizeClass(`w-full grid-cols-1 gap-3 grid  ${
                _ctx.selectedServiceAssessment.questions?.length == 0
                  ? 'bg-gray-100 h-[140px] rounded-lg'
                  : ''
              }`),
                          modelValue: _ctx.selectedServiceAssessment.questions,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedServiceAssessment.questions) = $event)),
                          "item-key": "uuid",
                          group: "questions"
                        }, _createSlots({
                          item: _withCtx(({ element, index }) => [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _createVNode(_component_roof_normal_text, { customClass: '!font-semibold !text-sm' }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Question " + _toDisplayString(index + 1), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createElementVNode("div", {
                                  class: "px-4 text-center text-bodyDark focus:outline-none",
                                  contenteditable: "true",
                                  onInput: ($event: any) => (_ctx.questionContentUpdate($event, element))
                                }, _toDisplayString(element.body), 41, _hoisted_29)
                              ]),
                              _createVNode(_component_roof_multiple_choice, {
                                hasTitle: false,
                                updateValue: element.options || '[]',
                                defaultAnswer: element.answer,
                                onOnUpdated: _ctx.updateQuestion,
                                "extra-id": element.uuid
                              }, null, 8, ["updateValue", "defaultAnswer", "onOnUpdated", "extra-id"])
                            ])
                          ]),
                          _: 2
                        }, [
                          (_ctx.selectedServiceAssessment.questions.length == 0)
                            ? {
                                name: "footer",
                                fn: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_30, [
                                    _createVNode(_component_roof_normal_text, { color: 'text-gray-400' }, {
                                      default: _withCtx(() => [
                                        _hoisted_31
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              }
                            : undefined
                        ]), 1032, ["class", "modelValue"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              _hoisted_32
            ]))
      ])
    ])
  ]))
}